import {
	array, object, oneOfType,string
} from 'prop-types';
import React from 'react';

import { Container } from './styles';

const TextBubble = ({
	bgColor, children,
}) => (
	<Container bgColor={bgColor}>
		{children}
	</Container>
);

export default TextBubble;
TextBubble.propTypes = {
	bgColor: string,
	children: oneOfType([array, object]),
}
